// 일정 신규 등록 시 기본 길이(시간). 모든 일정 생성 진입점과 ScheduleCreate 가 공유한다 (U-16).
export const DEFAULT_SCHEDULE_HOURS = 3;
